/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Creativeservicev1Checks } from '../models/Creativeservicev1Checks';
import { Creativeservicev1HealthCondition } from '../models/Creativeservicev1HealthCondition';
import { HttpFile } from '../http/http';

export class Creativeservicev1HealthCheck {
    'serviceName'?: string;
    'healthCondition'?: Creativeservicev1HealthCondition;
    'commitHash'?: string;
    'serviceVersion'?: string;
    'checks'?: Creativeservicev1Checks;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "serviceName",
            "baseName": "serviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "healthCondition",
            "baseName": "healthCondition",
            "type": "Creativeservicev1HealthCondition",
            "format": ""
        },
        {
            "name": "commitHash",
            "baseName": "commitHash",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceVersion",
            "baseName": "serviceVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "checks",
            "baseName": "checks",
            "type": "Creativeservicev1Checks",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Creativeservicev1HealthCheck.attributeTypeMap;
    }

    public constructor() {
    }
}

